import styled from "styled-components";
export const Card = styled.div`
  padding: 1rem;
  border: 1px solid rgba(225, 225, 225, 0.7);
  background-color: rgba(225, 225, 225, 0.3);
  border-radius: 7px;
`;
